var lists_default = {
  "fontElementMap": "rjR7K",
  "orderedlist": "dVLdy",
  "bulletedlist": "_1g2Ed",
  "listItem": "my-qv"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
